export default function Django_Compiler() {
  return <div>Django_Compiler Component</div>;
}
